import { httpRequest } from "@services/http"


export class CommandGetEngagementMetrics {
    async run(engagementId: number) {
      const url = `${
        import.meta.env.VITE_API_PLATFORM_SERVICE_URL
      }api/v1/engagements/${engagementId}/metrics/`
      try {
        const response = await httpRequest<any>(url, { method: "GET" })
        return response
      } catch (error) {
        console.error("Error fetching data:", error)
        throw error
      }
    }

}